var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-highlight",style:({ width: (_vm.width + "px"), transform: ("translateX(" + _vm.offsetX + "px)") })})}
var staticRenderFns = []

export { render, staticRenderFns }